import {useQuery} from '@tanstack/react-query';
import {useAppContext} from '../libs/appContextLib';
import {fetchExistingScenarios} from './useFetchExistingScenarios';
import {SAVED_SCENARIOS_CACHE_TIME} from './useFetchSavedScenarios';

export const getScenarioCalculatedInputsQueryKey = (accountId) => [`${accountId}_scenario-calculated-inputs`];

export async function fetchScenarioCalculatedInputs({accountIdOverride} = {}) {
    // Both statistics variants are account-wide; scenario_ids only filters the
    // saved_scenarios portion of this endpoint. The virtual default ID avoids
    // downloading parent records that are already fetched via saved-scenarios.
    const data = await fetchExistingScenarios({scenarioIds: ['default'], accountIdOverride});
    if (!data?.inputs || !data?.inputs_enforce_new_false) {
        throw new Error('Scenario input statistics could not be loaded. Please retry.');
    }
    return {inputs: data.inputs, inputs_enforce_new_false: data.inputs_enforce_new_false};
}

export function useScenarioCalculatedInputs({accountIdOverride = null, enabled = true} = {}) {
    const {currUser} = useAppContext();
    const accountId = accountIdOverride || currUser?.customerId;
    return useQuery({
        // Separate from saved-record caches: opening a tab saves its open state,
        // which cancels record reads. It must never cancel input statistics.
        queryKey: getScenarioCalculatedInputsQueryKey(accountId),
        queryFn: () => fetchScenarioCalculatedInputs({accountIdOverride: accountId}),
        enabled: Boolean(enabled && accountId && currUser?.authToken),
        staleTime: 60 * 1000,
        gcTime: SAVED_SCENARIOS_CACHE_TIME,
        refetchOnMount: 'always',
        refetchOnWindowFocus: false,
    });
}
